import React, { useEffect, useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle, ArrowRight } from "lucide-react";

export default function PaymentSuccess() {
  const { user, refresh } = useAuth();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    let timer;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          refresh();
          return;
        }
        if (r.data.status === "expired") {
          setStatus("expired");
          return;
        }
        if (attempts >= 8) { setStatus("timeout"); return; }
        timer = setTimeout(poll, 2000);
      } catch (e) {
        setStatus("error");
      }
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line
  }, [sessionId]);

  if (!user) return <Navigate to="/login" replace />;

  return (
    <div data-testid="payment-success-page" className="max-w-2xl mx-auto px-6 py-16">
      <div className="border border-zinc-800 bg-[var(--wb-surface)] p-12 text-center">
        {status === "polling" && (
          <>
            <Loader2 className="w-12 h-12 text-gold-500 mx-auto mb-6 animate-spin" />
            <h1 className="font-display font-black text-3xl">Spracúvam platbu…</h1>
            <p className="text-zinc-400 mt-2">Sekundu prosím.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto mb-6" />
            <h1 className="font-display font-black text-3xl">Vitaj v PRO!</h1>
            <p className="text-zinc-400 mt-2">Tvoje predplatné je aktívne. Užívaj komunitu a AI 5 správ/deň.</p>
            <Link data-testid="goto-community" to="/community" className="wb-btn-primary inline-flex items-center gap-2 mt-8 px-6 py-3 text-sm">
              Do komunity <ArrowRight className="w-4 h-4" />
            </Link>
          </>
        )}
        {(status === "expired" || status === "error" || status === "timeout") && (
          <>
            <XCircle className="w-12 h-12 text-red-500 mx-auto mb-6" />
            <h1 className="font-display font-black text-3xl">Platba sa nepodarila</h1>
            <p className="text-zinc-400 mt-2">Skús to znova alebo kontaktuj podporu.</p>
            <Link to="/pricing" className="wb-btn-ghost inline-block mt-8 px-6 py-3 text-sm">Späť na plány</Link>
          </>
        )}
      </div>
    </div>
  );
}
